<template>
  <transition name="fade-animation" mode="out-in">
    <div class="uploader-form-file" :class="{ 'inactive': isOfficeLogin }">
      <div class="uploader-form-file__content">
        <div class="uploader-form-file__wrapper">
          <img class="uploader-form-file__icon" alt="" aria-hidden="true"
            src="@/assets/images/icons/i_homework-file.svg" />
          <div class="flex flex-col">
            <div class="uploader-form-file__name">{{ upload.file.name }}</div>
            <div class="uploader-form-file__date">
              {{ formatDate }} | {{ formatFileSize(upload.file.size) }}
            </div>
          </div>
        </div>
      </div>
      <div class="uploader-form-file__status flex self-start">
        <div v-if="statusError" class="failed-status">
          <button @click="cancelUpload">
            <img src="@/assets/images/icons/close-pink.svg" />
          </button>
        </div>
        <UploaderProgress v-if="state === states.UPLOADING" class="status" :progress="progress" />
        <div v-if="state === states.COMPLETE" class="failed-status">
          <button @click="removeFile(upload.file.student_id, upload.file.homework_id, upload.file.id)">
            <img src="@/assets/images/icons/i_homework-close.svg" />
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import apiUpload from "@/helpers/apiUpload";
import axios from "axios";
import states from "./states";

import UploaderProgress from "./UploaderProgress.vue";

export default {
  components: {
    UploaderProgress
  },

  props: {
    upload: {
      required: true,
      type: Object
    },

    currentFilesSize: {
      type: Number
    },

    maxFilesSize: {
      type: Number
    },

    endpoint: {
      required: true
    }
  },

  data() {
    return {
      state: null,
      progress: 0,

      axios: {
        cancel: null
      },

      states
    };
  },

  computed: {
    ...mapState("students", ["student"]),
    ...mapGetters('auth', ['isOfficeLogin']),
    statusError() {
      if (
        this.state === this.states.FAILED ||
        this.state === this.states.CANCELLED ||
        this.state === this.states.UNSUPPORTED
      ) {
        return true;
      }
      return false;
    },

    sizeDisplay() {
      return (this.upload.file.size / 1000000).toFixed(2);
    },

    formatDate() {
      return moment(new Date()).format("HH:mm | DD.MM.YYYY");
    }
  },

  watch: {
    "upload.queued"(queued) {
      if (this.state === states.UNSUPPORTED) {
        return;
      }

      if (queued === false) {
        this.startUpload();
      }
    },

    progress(progress) {
      this.$emit("progress", {
        id: this.upload.id,
        progress
      });
    },

    state(state) {
      this.$emit("change", {
        id: this.upload.id,
        state
      });

      switch (state) {
        case states.CANCELLED:
        case states.FAILED:
          this.progress = 0;
          this.cancelUpload();
          break;
      }
    }
  },

  methods: {

    async errorSizeModal() {
      await swal.fire({
        title: this.$t("modal.error_size.title"),
        text: this.$t("modal.error_size.text"),
        confirmButtonText: this.$t("modal.error_size.confirm"),
        buttonsStyling: false,
        icon: "error",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "swal2-confirm-custom"
        }
      });
    },

    async errorSizeFileModal() {
      await swal.fire({
        title: this.$t("modal.error_size_single_file.title"),
        text: this.$t("modal.error_size_single_file.text"),
        confirmButtonText: this.$t("modal.error_size_single_file.confirm"),
        buttonsStyling: false,
        icon: "error",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "swal2-confirm-custom"
        }
      });
    },

    cancelUploading() {
      this.axios.cancel();
    },

    makeFormData(file) {
      const form = new FormData();
      form.append("file", file);
      form.append("student_id", this.student.id);
      form.append("homework_id", Number(this.$route.params.id));
      return form;
    },
    handleUploadProgress(e) {
      const targetProgress = Math.round((e.loaded * 100) / e.total);

      const step = () => {
        if (this.progress < targetProgress) {
          this.progress += Math.max((targetProgress - this.progress) / 10, 1);
          requestAnimationFrame(step);
        } else if (this.progress >= 99 && this.progress < 100) {
          this.progress = 100;
        }
      };

      requestAnimationFrame(step);
    },
    removeFile() {
      this.$emit("remove-file", {
        id: this.upload.id,
        size: this.upload.size,
      });
    },

    cancelUpload() {
      this.$emit("cancel-upload", {
        id: this.upload.id,
      });
    },

    async startUpload() {
      this.state = states.UPLOADING;
      try {
        if (this.currentFilesSize + this.upload.file.size > this.maxFilesSize) {
          this.errorSizeModal();
          this.state = states.FAILED;
          return null;
        } else {
          const file = this.makeFormData(this.upload.file);
          const response = await apiUpload.post(this.endpoint, file, {
            onUploadProgress: this.handleUploadProgress,
            cancelToken: new axios.CancelToken(token => {
              this.axios.cancel = token;
            })
          });
          const responseData = response.data.data;
          this.$emit("get-file-id", {
            id: this.upload.id,
            file_id: responseData.id,
          });
          this.$emit("finish");
          setTimeout(() => {
            this.state = states.COMPLETE;
          }, 500);
        }
      } catch (e) {
        console.error(e);
        if (e instanceof axios.Cancel) {
          return (this.state = states.CANCELLED);
        }
        if (e?.response?.status === 422) {
          this.errorSizeFileModal();
        }
        this.state = states.FAILED;
      }
    },
    formatFileSize(fileSize) {
      const fileExtension = ["Bytes", "KB", "MB", "GB"];
      let i = 0;
      while (fileSize > 900) {
        fileSize /= 1024; // eslint-disable-line no-param-reassign
        i += 1;
      }
      return `${Math.round(fileSize * 100) / 100} ${fileExtension[i]}`;
    }
  },

  mounted() {
    if (this.endpoint === null) {
      return (this.state = states.UNSUPPORTED);
    }

    this.state = states.WAITING;
  }
};
</script>

<style lang="scss" scoped>
.uploader-form-file {
  position: relative;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  border: 1px solid #E7E9EE;
  background: #FFF;

  @media screen and (min-width: 1280px) {
    max-width: 440px;
  }

  &.inactive {
    display: none;
  }

  @media screen and (min-width: 340px) {
    @apply flex-row items-center;
  }

  &__content {
    @apply flex flex-col justify-between items-start text-black leading-tight mb-2;

    @media screen and (min-width: 768px) {
      @apply mb-0;
    }
  }


  &__wrapper {
    display: flex;
    gap: 12px;
  }

  &__name {
    color: #111724;
    text-overflow: ellipsis;
    font-family: "GT Walsheim Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    max-width: 150px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
  }

  &__icon {
    width: 20px;
    height: 20px;
    align-items: flex-start;
  }

  &__date {
    color: #5B657A;
    font-family: "GT Walsheim Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 12px;
    white-space: nowrap;
    /* 128.571% */
  }

  &__status {
    position: absolute;
    top: 16px;
    right: 16px;

    @apply w-full flex justify-end items-center font-bold text-sm pl-2;

    @media screen and (min-width: 340px) {
      width: auto;
    }

    .failed-status {
      button {
        @apply flex justify-center items-center outline-none;
        cursor: pointer;
        gap: 4px;
        color: #2E384A;
        font-family: "GT Walsheim Pro";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        transition: 0.3s;
        white-space: nowrap;

        &:hover {
          color: #E10A7B;
          opacity: 0.6;
        }
      }
    }

    .cancel-status {
      @apply absolute my-0 ml-4 mr-2 w-6 h-6;
      top: -25px;
      right: -15px;

      button {
        @apply outline-none;
      }

      @media screen and (min-width: 768px) {
        top: 10px;
        right: -60px;
      }
    }
  }

  &__waiting,
  &__complete,
  &__uploading {
    @apply text-green-light;
  }

  &__failed,
  &__cancelled,
  &__unsupported {
    @apply text-red;
  }

  &__uploading {
    @apply text-center text-blue-dark;

    span,
    a {
      @apply block;
    }
  }

  .fade-animation-enter-active {
    transition: all 0.4s ease;
  }

  .fade-animation-leave-active {
    transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .fade-animation-enter,
  .fade-animation-leave-to {
    transform: translateY(-5px);
    opacity: 0;
  }
}
</style>
